<template>
  <v-panel>
    <v-form ref="form">
      <div class="divider">
        <span>
          <b>Dados dos Recursos - Máquinas e Equipamentos</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Máquinas e equipamentos</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas01"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas01"
                  background-color="white"
                  @input="emitirMudancaDeTitulo1(formulario.TituloMaquinas01)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade01"
                  v-model="formulario.MaquinasUnidade01"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade01"
                  v-model="formulario.MaquinasQuantidade01"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial01"
                      v-model="formulario.MaquinasValorInicial01"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual01"
                      v-model="formulario.MaquinasValorResidual01"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil01"
                  v-model="formulario.MaquinasVidaUtil01"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura01"
                  v-model="formulario.MaquinasBovinoCultura01"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas02"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas02"
                  background-color="white"
                  @input="emitirMudancaDeTitulo2(formulario.TituloMaquinas02)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade02"
                  v-model="formulario.MaquinasUnidade02"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade02"
                  v-model="formulario.MaquinasQuantidade02"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial02"
                      v-model="formulario.MaquinasValorInicial02"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual02"
                      v-model="formulario.MaquinasValorResidual02"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil02"
                  v-model="formulario.MaquinasVidaUtil02"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura02"
                  v-model="formulario.MaquinasBovinoCultura02"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas03"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas03"
                  background-color="white"
                  @input="emitirMudancaDeTitulo3(formulario.TituloMaquinas03)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade03"
                  v-model="formulario.MaquinasUnidade03"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade03"
                  v-model="formulario.MaquinasQuantidade03"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial03"
                      v-model="formulario.MaquinasValorInicial03"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual03"
                      v-model="formulario.MaquinasValorResidual03"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil03"
                  v-model="formulario.MaquinasVidaUtil03"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura03"
                  v-model="formulario.MaquinasBovinoCultura03"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas04"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas04"
                  background-color="white"
                  @input="emitirMudancaDeTitulo4(formulario.TituloMaquinas04)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade04"
                  v-model="formulario.MaquinasUnidade04"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade04"
                  v-model="formulario.MaquinasQuantidade04"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial04"
                      v-model="formulario.MaquinasValorInicial04"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual04"
                      v-model="formulario.MaquinasValorResidual04"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil04"
                  v-model="formulario.MaquinasVidaUtil04"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura04"
                  v-model="formulario.MaquinasBovinoCultura04"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas05"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas05"
                  background-color="white"
                  @input="emitirMudancaDeTitulo5(formulario.TituloMaquinas05)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade05"
                  v-model="formulario.MaquinasUnidade05"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade05"
                  v-model="formulario.MaquinasQuantidade05"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial05"
                      v-model="formulario.MaquinasValorInicial05"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual05"
                      v-model="formulario.MaquinasValorResidual05"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil05"
                  v-model="formulario.MaquinasVidaUtil05"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura05"
                  v-model="formulario.MaquinasBovinoCultura05"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas06"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas06"
                  background-color="white"
                  @input="emitirMudancaDeTitulo6(formulario.TituloMaquinas06)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade06"
                  v-model="formulario.MaquinasUnidade06"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade06"
                  v-model="formulario.MaquinasQuantidade06"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial06"
                      v-model="formulario.MaquinasValorInicial06"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual06"
                      v-model="formulario.MaquinasValorResidual06"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil06"
                  v-model="formulario.MaquinasVidaUtil06"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura06"
                  v-model="formulario.MaquinasBovinoCultura06"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas07"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas07"
                  background-color="white"
                  @input="emitirMudancaDeTitulo7(formulario.TituloMaquinas07)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade07"
                  v-model="formulario.MaquinasUnidade07"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade07"
                  v-model="formulario.MaquinasQuantidade07"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial07"
                      v-model="formulario.MaquinasValorInicial07"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual07"
                      v-model="formulario.MaquinasValorResidual07"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil07"
                  v-model="formulario.MaquinasVidaUtil07"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura07"
                  v-model="formulario.MaquinasBovinoCultura07"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas08"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas08"
                  background-color="white"
                  @input="emitirMudancaDeTitulo8(formulario.TituloMaquinas08)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade08"
                  v-model="formulario.MaquinasUnidade08"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade08"
                  v-model="formulario.MaquinasQuantidade08"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial08"
                      v-model="formulario.MaquinasValorInicial08"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual08"
                      v-model="formulario.MaquinasValorResidual08"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil08"
                  v-model="formulario.MaquinasVidaUtil08"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura08"
                  v-model="formulario.MaquinasBovinoCultura08"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas09"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas09"
                  background-color="white"
                  @input="emitirMudancaDeTitulo9(formulario.TituloMaquinas09)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade09"
                  v-model="formulario.MaquinasUnidade09"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade09"
                  v-model="formulario.MaquinasQuantidade09"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial09"
                      v-model="formulario.MaquinasValorInicial09"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual09"
                      v-model="formulario.MaquinasValorResidual09"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil09"
                  v-model="formulario.MaquinasVidaUtil09"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura09"
                  v-model="formulario.MaquinasBovinoCultura09"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas10"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas10"
                  background-color="white"
                  @input="emitirMudancaDeTitulo10(formulario.TituloMaquinas10)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade10"
                  v-model="formulario.MaquinasUnidade10"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade10"
                  v-model="formulario.MaquinasQuantidade10"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial10"
                      v-model="formulario.MaquinasValorInicial10"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual10"
                      v-model="formulario.MaquinasValorResidual10"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil10"
                  v-model="formulario.MaquinasVidaUtil10"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura10"
                  v-model="formulario.MaquinasBovinoCultura10"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas11"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas11"
                  background-color="white"
                  @input="emitirMudancaDeTitulo11(formulario.TituloMaquinas11)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade11"
                  v-model="formulario.MaquinasUnidade11"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade11"
                  v-model="formulario.MaquinasQuantidade11"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial11"
                      v-model="formulario.MaquinasValorInicial11"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual11"
                      v-model="formulario.MaquinasValorResidual11"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil11"
                  v-model="formulario.MaquinasVidaUtil11"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura11"
                  v-model="formulario.MaquinasBovinoCultura11"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas12"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas12"
                  background-color="white"
                  @input="emitirMudancaDeTitulo12(formulario.TituloMaquinas12)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade12"
                  v-model="formulario.MaquinasUnidade12"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade12"
                  v-model="formulario.MaquinasQuantidade12"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial12"
                      v-model="formulario.MaquinasValorInicial12"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual12"
                      v-model="formulario.MaquinasValorResidual12"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil12"
                  v-model="formulario.MaquinasVidaUtil12"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura12"
                  v-model="formulario.MaquinasBovinoCultura12"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas13"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas13"
                  background-color="white"
                  @input="emitirMudancaDeTitulo13(formulario.TituloMaquinas13)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade13"
                  v-model="formulario.MaquinasUnidade13"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade13"
                  v-model="formulario.MaquinasQuantidade13"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial13"
                      v-model="formulario.MaquinasValorInicial13"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual13"
                      v-model="formulario.MaquinasValorResidual13"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil13"
                  v-model="formulario.MaquinasVidaUtil13"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura13"
                  v-model="formulario.MaquinasBovinoCultura13"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas14"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas14"
                  background-color="white"
                  @input="emitirMudancaDeTitulo14(formulario.TituloMaquinas14)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade14"
                  v-model="formulario.MaquinasUnidade14"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade14"
                  v-model="formulario.MaquinasQuantidade14"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial14"
                      v-model="formulario.MaquinasValorInicial14"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual14"
                      v-model="formulario.MaquinasValorResidual14"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil14"
                  v-model="formulario.MaquinasVidaUtil14"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura14"
                  v-model="formulario.MaquinasBovinoCultura14"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas15"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas15"
                  background-color="white"
                  @input="emitirMudancaDeTitulo15(formulario.TituloMaquinas15)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade15"
                  v-model="formulario.MaquinasUnidade15"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade15"
                  v-model="formulario.MaquinasQuantidade15"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial15"
                      v-model="formulario.MaquinasValorInicial15"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual15"
                      v-model="formulario.MaquinasValorResidual15"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil15"
                  v-model="formulario.MaquinasVidaUtil15"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura15"
                  v-model="formulario.MaquinasBovinoCultura15"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas16"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas16"
                  background-color="white"
                  @input="emitirMudancaDeTitulo16(formulario.TituloMaquinas16)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade16"
                  v-model="formulario.MaquinasUnidade16"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade16"
                  v-model="formulario.MaquinasQuantidade16"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial16"
                      v-model="formulario.MaquinasValorInicial16"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual16"
                      v-model="formulario.MaquinasValorResidual16"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil16"
                  v-model="formulario.MaquinasVidaUtil16"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura16"
                  v-model="formulario.MaquinasBovinoCultura16"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas17"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas17"
                  background-color="white"
                  @input="emitirMudancaDeTitulo17(formulario.TituloMaquinas17)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade17"
                  v-model="formulario.MaquinasUnidade17"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade17"
                  v-model="formulario.MaquinasQuantidade17"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial17"
                      v-model="formulario.MaquinasValorInicial17"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual17"
                      v-model="formulario.MaquinasValorResidual17"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil17"
                  v-model="formulario.MaquinasVidaUtil17"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura17"
                  v-model="formulario.MaquinasBovinoCultura17"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas18"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas18"
                  background-color="white"
                  @input="emitirMudancaDeTitulo18(formulario.TituloMaquinas18)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade18"
                  v-model="formulario.MaquinasUnidade18"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade18"
                  v-model="formulario.MaquinasQuantidade18"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial18"
                      v-model="formulario.MaquinasValorInicial18"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual18"
                      v-model="formulario.MaquinasValorResidual18"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil18"
                  v-model="formulario.MaquinasVidaUtil18"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura18"
                  v-model="formulario.MaquinasBovinoCultura18"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas19"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas19"
                  background-color="white"
                  @input="emitirMudancaDeTitulo19(formulario.TituloMaquinas19)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade19"
                  v-model="formulario.MaquinasUnidade19"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade19"
                  v-model="formulario.MaquinasQuantidade19"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial19"
                      v-model="formulario.MaquinasValorInicial19"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual19"
                      v-model="formulario.MaquinasValorResidual19"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil19"
                  v-model="formulario.MaquinasVidaUtil19"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura19"
                  v-model="formulario.MaquinasBovinoCultura19"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas20"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas20"
                  background-color="white"
                  @input="emitirMudancaDeTitulo20(formulario.TituloMaquinas20)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade20"
                  v-model="formulario.MaquinasUnidade20"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade20"
                  v-model="formulario.MaquinasQuantidade20"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial20"
                      v-model="formulario.MaquinasValorInicial20"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual20"
                      v-model="formulario.MaquinasValorResidual20"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil20"
                  v-model="formulario.MaquinasVidaUtil20"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura20"
                  v-model="formulario.MaquinasBovinoCultura20"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas21"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas21"
                  background-color="white"
                  @input="emitirMudancaDeTitulo21(formulario.TituloMaquinas21)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade21"
                  v-model="formulario.MaquinasUnidade21"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade21"
                  v-model="formulario.MaquinasQuantidade21"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial21"
                      v-model="formulario.MaquinasValorInicial21"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual21"
                      v-model="formulario.MaquinasValorResidual21"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil21"
                  v-model="formulario.MaquinasVidaUtil21"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura21"
                  v-model="formulario.MaquinasBovinoCultura21"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas22"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas22"
                  background-color="white"
                  @input="emitirMudancaDeTitulo22(formulario.TituloMaquinas22)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade22"
                  v-model="formulario.MaquinasUnidade22"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade22"
                  v-model="formulario.MaquinasQuantidade22"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial22"
                      v-model="formulario.MaquinasValorInicial22"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual22"
                      v-model="formulario.MaquinasValorResidual22"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil22"
                  v-model="formulario.MaquinasVidaUtil22"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura22"
                  v-model="formulario.MaquinasBovinoCultura22"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas23"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas23"
                  background-color="white"
                  @input="emitirMudancaDeTitulo23(formulario.TituloMaquinas23)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade23"
                  v-model="formulario.MaquinasUnidade23"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade23"
                  v-model="formulario.MaquinasQuantidade23"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial23"
                      v-model="formulario.MaquinasValorInicial23"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual23"
                      v-model="formulario.MaquinasValorResidual23"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil23"
                  v-model="formulario.MaquinasVidaUtil23"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura23"
                  v-model="formulario.MaquinasBovinoCultura23"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas24"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas24"
                  background-color="white"
                  @input="emitirMudancaDeTitulo24(formulario.TituloMaquinas24)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade24"
                  v-model="formulario.MaquinasUnidade24"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade24"
                  v-model="formulario.MaquinasQuantidade24"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial24"
                      v-model="formulario.MaquinasValorInicial24"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual24"
                      v-model="formulario.MaquinasValorResidual24"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil24"
                  v-model="formulario.MaquinasVidaUtil24"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura24"
                  v-model="formulario.MaquinasBovinoCultura24"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas25"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas25"
                  background-color="white"
                  @input="emitirMudancaDeTitulo25(formulario.TituloMaquinas25)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade25"
                  v-model="formulario.MaquinasUnidade25"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade25"
                  v-model="formulario.MaquinasQuantidade25"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial25"
                      v-model="formulario.MaquinasValorInicial25"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual25"
                      v-model="formulario.MaquinasValorResidual25"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil25"
                  v-model="formulario.MaquinasVidaUtil25"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura25"
                  v-model="formulario.MaquinasBovinoCultura25"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas26"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas26"
                  background-color="white"
                  @input="emitirMudancaDeTitulo26(formulario.TituloMaquinas26)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade26"
                  v-model="formulario.MaquinasUnidade26"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade26"
                  v-model="formulario.MaquinasQuantidade26"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial26"
                      v-model="formulario.MaquinasValorInicial26"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual26"
                      v-model="formulario.MaquinasValorResidual26"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil26"
                  v-model="formulario.MaquinasVidaUtil26"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura26"
                  v-model="formulario.MaquinasBovinoCultura26"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas27"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas27"
                  background-color="white"
                  @input="emitirMudancaDeTitulo27(formulario.TituloMaquinas27)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade27"
                  v-model="formulario.MaquinasUnidade27"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade27"
                  v-model="formulario.MaquinasQuantidade27"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial27"
                      v-model="formulario.MaquinasValorInicial27"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual27"
                      v-model="formulario.MaquinasValorResidual27"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil27"
                  v-model="formulario.MaquinasVidaUtil27"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura27"
                  v-model="formulario.MaquinasBovinoCultura27"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas28"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas28"
                  background-color="white"
                  @input="emitirMudancaDeTitulo28(formulario.TituloMaquinas28)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade28"
                  v-model="formulario.MaquinasUnidade28"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade28"
                  v-model="formulario.MaquinasQuantidade28"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial28"
                      v-model="formulario.MaquinasValorInicial28"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual28"
                      v-model="formulario.MaquinasValorResidual28"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil28"
                  v-model="formulario.MaquinasVidaUtil28"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura28"
                  v-model="formulario.MaquinasBovinoCultura28"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas29"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas29"
                  background-color="white"
                  @input="emitirMudancaDeTitulo29(formulario.TituloMaquinas29)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade29"
                  v-model="formulario.MaquinasUnidade29"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade29"
                  v-model="formulario.MaquinasQuantidade29"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial29"
                      v-model="formulario.MaquinasValorInicial29"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual29"
                      v-model="formulario.MaquinasValorResidual29"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil29"
                  v-model="formulario.MaquinasVidaUtil29"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura29"
                  v-model="formulario.MaquinasBovinoCultura29"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas30"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas30"
                  background-color="white"
                  @input="emitirMudancaDeTitulo30(formulario.TituloMaquinas30)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade30"
                  v-model="formulario.MaquinasUnidade30"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade30"
                  v-model="formulario.MaquinasQuantidade30"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial30"
                      v-model="formulario.MaquinasValorInicial30"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual30"
                      v-model="formulario.MaquinasValorResidual30"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil30"
                  v-model="formulario.MaquinasVidaUtil30"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura30"
                  v-model="formulario.MaquinasBovinoCultura30"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas31"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas31"
                  background-color="white"
                  @input="emitirMudancaDeTitulo31(formulario.TituloMaquinas31)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade31"
                  v-model="formulario.MaquinasUnidade31"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade31"
                  v-model="formulario.MaquinasQuantidade31"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial31"
                      v-model="formulario.MaquinasValorInicial31"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual31"
                      v-model="formulario.MaquinasValorResidual31"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil31"
                  v-model="formulario.MaquinasVidaUtil31"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura31"
                  v-model="formulario.MaquinasBovinoCultura31"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas32"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas32"
                  background-color="white"
                  @input="emitirMudancaDeTitulo32(formulario.TituloMaquinas32)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade32"
                  v-model="formulario.MaquinasUnidade32"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade32"
                  v-model="formulario.MaquinasQuantidade32"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial32"
                      v-model="formulario.MaquinasValorInicial32"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual32"
                      v-model="formulario.MaquinasValorResidual32"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil32"
                  v-model="formulario.MaquinasVidaUtil32"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura32"
                  v-model="formulario.MaquinasBovinoCultura32"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas33"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas33"
                  background-color="white"
                  @input="emitirMudancaDeTitulo33(formulario.TituloMaquinas33)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade33"
                  v-model="formulario.MaquinasUnidade33"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade33"
                  v-model="formulario.MaquinasQuantidade33"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial33"
                      v-model="formulario.MaquinasValorInicial33"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual33"
                      v-model="formulario.MaquinasValorResidual33"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil33"
                  v-model="formulario.MaquinasVidaUtil33"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura33"
                  v-model="formulario.MaquinasBovinoCultura33"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas34"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas34"
                  background-color="white"
                  @input="emitirMudancaDeTitulo34(formulario.TituloMaquinas34)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade34"
                  v-model="formulario.MaquinasUnidade34"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade34"
                  v-model="formulario.MaquinasQuantidade34"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial34"
                      v-model="formulario.MaquinasValorInicial34"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual34"
                      v-model="formulario.MaquinasValorResidual34"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil34"
                  v-model="formulario.MaquinasVidaUtil34"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura34"
                  v-model="formulario.MaquinasBovinoCultura34"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloMaquinas35"
                  placeholder="Itens"
                  v-model="formulario.TituloMaquinas35"
                  background-color="white"
                  @input="emitirMudancaDeTitulo35(formulario.TituloMaquinas35)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasUnidade35"
                  v-model="formulario.MaquinasUnidade35"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasQuantidade35"
                  v-model="formulario.MaquinasQuantidade35"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorInicial35"
                      v-model="formulario.MaquinasValorInicial35"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="MaquinasValorResidual35"
                      v-model="formulario.MaquinasValorResidual35"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasVidaUtil35"
                  v-model="formulario.MaquinasVidaUtil35"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="MaquinasBovinoCultura35"
                  v-model="formulario.MaquinasBovinoCultura35"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Taxa de juros para calcular o custo do capital imobilizado em máquinas e equipamentos</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <v-text-field
              name="TaxaJurosMaquinas"
              v-model="formulario.TaxaJurosMaquinas"
              type="number"
              background-color="white"
              label="% anual"
              box
            ></v-text-field>
            {{form}}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import { EventBus } from "../../event-bus.js";

export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosRecursosMaquinas(),
    panel: [],
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    },

    emitirMudancaDeTitulo1(titulo21) {
      EventBus.$emit("titulo-maquinas01", titulo21);
    },
    emitirMudancaDeTitulo2(titulo22) {
      EventBus.$emit("titulo-maquinas02", titulo22);
    },
    emitirMudancaDeTitulo3(titulo23) {
      EventBus.$emit("titulo-maquinas03", titulo23);
    },
    emitirMudancaDeTitulo4(titulo24) {
      EventBus.$emit("titulo-maquinas04", titulo24);
    },
    emitirMudancaDeTitulo5(titulo25) {
      EventBus.$emit("titulo-maquinas05", titulo25);
    },
    emitirMudancaDeTitulo6(titulo26) {
      EventBus.$emit("titulo-maquinas06", titulo26);
    },
    emitirMudancaDeTitulo7(titulo27) {
      EventBus.$emit("titulo-maquinas07", titulo27);
    },
    emitirMudancaDeTitulo8(titulo28) {
      EventBus.$emit("titulo-maquinas08", titulo28);
    },
    emitirMudancaDeTitulo9(titulo29) {
      EventBus.$emit("titulo-maquinas09", titulo29);
    },
    emitirMudancaDeTitulo10(titulo30) {
      EventBus.$emit("titulo-maquinas10", titulo30);
    },
    emitirMudancaDeTitulo11(titulo31) {
      EventBus.$emit("titulo-maquinas11", titulo31);
    },
    emitirMudancaDeTitulo12(titulo32) {
      EventBus.$emit("titulo-maquinas12", titulo32);
    },
    emitirMudancaDeTitulo13(titulo33) {
      EventBus.$emit("titulo-maquinas13", titulo33);
    },
    emitirMudancaDeTitulo14(titulo34) {
      EventBus.$emit("titulo-maquinas14", titulo34);
    },
    emitirMudancaDeTitulo15(titulo35) {
      EventBus.$emit("titulo-maquinas15", titulo35);
    },
    emitirMudancaDeTitulo16(titulo36) {
      EventBus.$emit("titulo-maquinas16", titulo36);
    },
    emitirMudancaDeTitulo17(titulo37) {
      EventBus.$emit("titulo-maquinas17", titulo37);
    },
    emitirMudancaDeTitulo18(titulo38) {
      EventBus.$emit("titulo-maquinas18", titulo38);
    },
    emitirMudancaDeTitulo19(titulo39) {
      EventBus.$emit("titulo-maquinas19", titulo39);
    },
    emitirMudancaDeTitulo20(titulo40) {
      EventBus.$emit("titulo-maquinas20", titulo40);
    },
    emitirMudancaDeTitulo21(titulo41) {
      EventBus.$emit("titulo-maquinas21", titulo41);
    },
    emitirMudancaDeTitulo22(titulo42) {
      EventBus.$emit("titulo-maquinas22", titulo42);
    },
    emitirMudancaDeTitulo23(titulo43) {
      EventBus.$emit("titulo-maquinas23", titulo43);
    },
    emitirMudancaDeTitulo24(titulo44) {
      EventBus.$emit("titulo-maquinas24", titulo44);
    },
    emitirMudancaDeTitulo25(titulo45) {
      EventBus.$emit("titulo-maquinas25", titulo45);
    },
    emitirMudancaDeTitulo26(titulo46) {
      EventBus.$emit("titulo-maquinas26", titulo46);
    },
    emitirMudancaDeTitulo27(titulo47) {
      EventBus.$emit("titulo-maquinas27", titulo47);
    },
    emitirMudancaDeTitulo28(titulo48) {
      EventBus.$emit("titulo-maquinas28", titulo48);
    },
    emitirMudancaDeTitulo29(titulo49) {
      EventBus.$emit("titulo-maquinas29", titulo49);
    },
    emitirMudancaDeTitulo30(titulo50) {
      EventBus.$emit("titulo-maquinas30", titulo50);
    },
    emitirMudancaDeTitulo31(titulo51) {
      EventBus.$emit("titulo-maquinas31", titulo51);
    },
    emitirMudancaDeTitulo32(titulo52) {
      EventBus.$emit("titulo-maquinas32", titulo52);
    },
    emitirMudancaDeTitulo33(titulo53) {
      EventBus.$emit("titulo-maquinas33", titulo53);
    },
    emitirMudancaDeTitulo34(titulo54) {
      EventBus.$emit("titulo-maquinas34", titulo54);
    },
    emitirMudancaDeTitulo35(titulo55) {
      EventBus.$emit("titulo-maquinas35", titulo55);
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;
    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
    color: azure;
  }
  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;
    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .select {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;
    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>